import {interopDefault} from '@/utils/helpers'

const FlightsPage = () => interopDefault(import('~/pages/flights/FlightsPage'))
const FlightsSchedulePage = () => interopDefault(import('~/pages/flights/FlightsSchedulePage'))
const FlightsAvailabilityPage = () => interopDefault(import('~/pages/flights/FlightsAvailabilityPage'))
const FlightBookingPage = () => interopDefault(import('~src/pages/flights/flightBookingPage.src'))
const FlightConfirmationPage = () => interopDefault(import('~/pages/flights/FlightConfirmationPage'))

export default [
    {
        path: '/search/flights',
        component: FlightsPage,
        name: 'flights',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/flights/schedule',
        component: FlightsSchedulePage,
        name: 'flightsSchedule',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/flights/availability',
        component: FlightsAvailabilityPage,
        name: 'flightsAvailability',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/flights/booking',
        component: FlightBookingPage,
        name: 'flightBooking',
        beforeEnter: (to, from, next) => {
            if (!to.query.offerKey) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
            validate: route => !!route.query.offerKey,
        },
    },
    {
        path: '/flights/confirmation',
        component: FlightConfirmationPage,
        name: 'flightConfirmation',
        beforeEnter: (to, from, next) => {
            if (!to.query.orderId) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
        },
    },
]
